import {Dispatch} from 'redux'
import {getAccessToken} from 'setup/redux/Actions/Timetable/timetable'

import {getTheme} from '_metronic/partials'

const PLAN_SELECTION_PATH = '/PlanSelection'

type OpenPlanUpgradeOptions = {
  onStart?: () => void
  onComplete?: () => void
  onError?: (error: unknown) => void
}

/**
 * Base URL of the subscription app's AI credits page (usage view). The
 * da1timetable.info tenants use the dev subscription app.
 */
const getAiCreditsUrl = (): string | undefined =>
  window.location.hostname.includes('da1timetable.info')
    ? 'https://dev-subscription.ilmversity.ai/ai-credits'
    : import.meta.env.VITE_APP_AI_CREDITS_URL

/**
 * Fetch a subscription access token and send the browser to the subscription
 * app at `path` (relative to the AI credits URL), carrying the credentials,
 * source domain, theme and return URL the subscription app expects.
 */
function openSubscriptionPage(
  dispatch: Dispatch,
  path: string,
  extraQuery: string,
  options: OpenPlanUpgradeOptions
): void {
  const {onStart, onComplete, onError} = options
  onStart?.()

  dispatch(
    getAccessToken(
      (response: any) => {
        onComplete?.()
        const {accessToken, urdd_id} = response?.result || response || {}
        if (!accessToken || !urdd_id) return

        const aiCreditsUrl = getAiCreditsUrl()
        if (!aiCreditsUrl) return

        try {
          const sourceDomain = window.location.hostname
          const theme = getTheme()
          const returnTo = window.location.href
          const url = `${aiCreditsUrl.replace(/\/$/, '')}${path}?accessToken=${encodeURIComponent(accessToken)}&urdd_id=${encodeURIComponent(urdd_id)}&sourceDomain=${encodeURIComponent(sourceDomain)}&theme=${encodeURIComponent(theme)}&returnTo=${encodeURIComponent(returnTo)}${extraQuery}`
          window.location.href = url
        } catch (err) {
          onError?.(err)
        }
      },
      (error: unknown) => {
        onComplete?.()
        onError?.(error)
      }
    )
  )
}

/** Redirect to subscription plan selection (same flow as header Upgrade Plan). */
export function openPlanUpgradeSelection(
  dispatch: Dispatch,
  options: OpenPlanUpgradeOptions = {}
): void {
  openSubscriptionPage(dispatch, PLAN_SELECTION_PATH, '&intent=planSelection', options)
}

/**
 * Redirect to the AI credits usage page — the view the desktop coins pill and
 * the sidebar "View Details" open (not plan selection).
 */
export function openAiCreditsUsage(dispatch: Dispatch, options: OpenPlanUpgradeOptions = {}): void {
  openSubscriptionPage(dispatch, '', '', options)
}
